"use strict";

exports.__esModule = true;
exports.URLFilterContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a URL filter to consumers.
 * @component
 */
var URLFilterContext = exports.URLFilterContext = (0, _Utils.createEnhancedContext)({
  propName: "urlFilter"
});